module.exports = __webpack_public_path__ + "static/media/miguela.bc8e0a43.png";